import React from "react";
import EntryRow from "./EntryRow";

const WD = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const MON = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

// 9 columns: Code, Client, Task, Year End, Type, Hrs, Description, status, ✕/Send back
export default function DayGroup({
  dayISO, entries, clients, timeCodes, tasksByClient, otherTasksByClient = {},
  statusByKey, review,
  onChange, onDelete, onSendBack, onAddRow, onCreateTask, onSubmitDay,
}) {
  const dt = new Date(dayISO + "T00:00:00");
  const label = `${WD[dt.getDay()]} · ${MON[dt.getMonth()]} ${dt.getDate()}`;
  const dayHours = entries.reduce((s, e) => s + (Number(e.hours) || 0), 0);
  // Saved lines only (a padded blank row has no id). The day can be sent
  // while any of them is still a draft or was sent back.
  const saved = entries.filter((e) => e.id);
  const unsent = saved.filter((e) => !e.status || e.status === "draft" || e.status === "rejected");
  const dayState = !saved.length ? null
    : unsent.length ? "open"
    : saved.every((e) => e.status === "approved") ? "approved"
    : "submitted";

  return (
    <tbody>
      <tr className="te-day">
        <td className="te-day-cell" colSpan={5}>{label}</td>
        <td className="te-day-cell te-num-cell">{dayHours > 0 ? `${dayHours.toFixed(2)}h` : ""}</td>
        <td className="te-day-cell" colSpan={3} style={{ textAlign: "right" }}>
          {onSubmitDay && dayState === "open" && (
            <button
              type="button"
              className="te-submit-day"
              onClick={() => onSubmitDay(dayISO)}
              aria-label={`Submit ${label} for approval`}
              style={{
                padding: "2px 10px", fontSize: 12, fontWeight: 600,
                border: "1px solid #2563eb", borderRadius: 6,
                background: "white", color: "#2563eb", cursor: "pointer",
              }}
            >
              Submit day
            </button>
          )}
          {onSubmitDay && dayState === "submitted" && (
            <span style={{ fontSize: 12, color: "#6b7280" }}>Submitted</span>
          )}
          {onSubmitDay && dayState === "approved" && (
            <span style={{ fontSize: 12, color: "#059669" }}>Approved</span>
          )}
        </td>
      </tr>
      {entries.map((e) => (
        <EntryRow
          // _localKey first, and only then id. A locally added row gets its
          // server id about 800ms after the first keystroke, and if that
          // changed the key React would discard the row and build a new one --
          // dropping focus to <body> and closing the picker the user is
          // standing in. Server-loaded rows have no _localKey and key by id.
          key={e._localKey ?? e.id}
          entry={e}
          clients={clients}
          timeCodes={timeCodes}
          // No `|| []`: EntryRow distinguishes "not fetched yet" (undefined)
          // from "this client has no tasks" (empty array).
          tasks={tasksByClient[e.client]}
          otherTasks={otherTasksByClient[e.client]}
          editable={true}
          review={review}
          saveStatus={statusByKey[e._localKey ?? e.id]}
          onChange={(field, value) => onChange(e, field, value)}
          // The create row hands back what was typed; the row it was typed on
          // is what turns that into a task on the right client.
          onCreateTask={onCreateTask && ((query) => onCreateTask(e, query))}
          onDelete={() => onDelete(e)}
          onSendBack={onSendBack}
        />
      ))}
      {!review && (
        <tr className="te-add">
          <td colSpan={9}>
            <button className="te-add-btn" onClick={() => onAddRow(dayISO)}>+ add line</button>
          </td>
        </tr>
      )}
    </tbody>
  );
}
